module.exports = __webpack_public_path__ + "img/wonder64_ua.d11d4e61.webp";